import React from 'react';
import styled from 'styled-components';
import { Box, Heading, Paragraph, Text } from '@99designs/emu';
import { spaces } from '@99designs/emu/settings';
import PieChart from './Chart/PieChart';
import BarChartList from './Diversity/BarChartList';
import TextFullWidthMediaLayout from './TextFullWidthMediaLayout';
import { DWB21_Purple } from './colors';

const Wrapper = styled.div`
    max-width: 1440px;
`;

const MainHeading = styled(Heading)`
    text-align: left;
`;

const SubHeading = styled(Heading)`
    text-align: left;
    padding: ${spaces['2bu']} 0;
`;

const PieHeading = styled(Text)`
    font-size: 100px;
    line-height: 1.1;
`;
export default function Diversity() {
    return (
        <Wrapper>
            <TextFullWidthMediaLayout
                title={
                    <MainHeading appearanceLevel={0} accessibilityLevel={1} withDivider>
                        Diversity: the driving force in design
                    </MainHeading>
                }
                main={
                    <Box>
                        <SubHeading appearanceLevel={2} accessibilityLevel={2}>
                            Talent is everywhere. And it’s accessible.
                        </SubHeading>
                        <Paragraph align="left">
                            The freelance design community is made up of an infinite number of
                            creative viewpoints. While the industry as a whole is still
                            male-dominated (66%), freelancers come from a wide variety of
                            backgrounds and cultures, each with unique life experiences. And with
                            84% of designers working with clients in different time zones, they’re
                            sharing these diverse perspectives with clients around the world.
                        </Paragraph>
                    </Box>
                }
                aside={
                    <Box>
                        <Box display="flex" flexDirection="column" paddingBottom="1.5bu">
                            <PieHeading align="center" fontFamily="attribution" italic={true}>
                                1 in 5
                            </PieHeading>
                            <Text
                                size="size5"
                                align="center"
                                fontFamily="attribution"
                                italic={true}
                                lineHeight="textLarge"
                            >
                                identify as a minority
                            </Text>
                        </Box>
                        <Box display="flex" justifyContent="center">
                            <PieChart
                                percentage={20}
                                color={DWB21_Purple}
                                height="300px"
                                width="300px"
                            />
                        </Box>
                    </Box>
                }
                media={<BarChartList />}
            />
        </Wrapper>
    );
}
